import {VetologyBase} from "../Vetology/VetologyBase";

export class FormItemList extends VetologyBase {
    constructor() {
        super('FormItemList');
    }

    init() {
        const _self = this;
        let btnAdd = document.getElementById("btnAdd");

        btnAdd.addEventListener("click", function (event) {
            event.preventDefault();
            const params = _self.getParams();
            params.append('can_produce', '1');
            fetch(itemListData.add_url, {
                method: "post",
                body: params,
                headers: {
                    accept: 'application/json'
                }
            }).then((response) => {
                    if (response.ok) {
                        response.json().then(json => {
                            _self.addItem(json.results[0]);
                        });
                    }
                });
        });

        let items = itemListData.items;
        items.map(function (item) {
            _self.addItem(item);
        });

    }

    deleteItem(itemId) {
        const _self = this;
        let listItem = document.querySelector('div[data-id="' + itemId + '"]');
        if (listItem) {
            let params = _self.getParams();
            let deleteUrl = itemListData.delete_url;
            deleteUrl = deleteUrl.replace('{id}', itemId);
            params.append('can_produce', '1');
            fetch(deleteUrl, {
                method: "POST",
                body: params,
                headers: {
                    accept: 'application/json'
                }
            })
                .then((response) => {
                    if (response.ok) {
                        listItem.parentNode.removeChild(listItem);
                    }
                });
        }

    }


    addItem(item) {
        const _self = this;

        let listItem = document.createElement('div');
        listItem.classList.add('container');
        listItem.setAttribute('data-id', item.id);
        listItem.setAttribute('style', 'margin-bottom: 15px');

        let toggleButtons = document.createElement('div');
        toggleButtons.classList.add('btn-group', 'col-sm-4');
        toggleButtons.setAttribute('data-toggle', 'buttons');
        toggleButtons.setAttribute('style', 'display: flex; justify-content: end;');

        const radioOptions = itemListData.radio_options;

        Object.entries(radioOptions).map(function ([name, value]) {
            const label = document.createElement('label');
            label.classList.add('btn', 'btn-xs', 'btn-primary');

            if(item.is_active === value){
                label.classList.add('active');
            }
            label.innerHTML = '<input ' + (item.is_active === value ? 'checked="checked"' : '') + ' type="radio" value="' + value + '" name="' + item.id + '">' + name;
            label.addEventListener('click', function (e) {
                e.preventDefault();
                _self.enabled(e, item.id);
            });
            toggleButtons.appendChild(label);
        });

        let deleteButton = document.createElement('button');
        deleteButton.classList.add('btn', 'btn-danger', 'col-sm-1');
        deleteButton.setAttribute('data-id', item.id);
        deleteButton.textContent = itemListData.btn_delete_name ?? 'Delete';

        let nameLabel = document.createElement('label');
        nameLabel.classList.add('radio-form-label', 'col-sm-7', 'control-label', 'align-left');
        nameLabel.textContent = item.name;

        deleteButton.addEventListener('click', function (e) {
            e.preventDefault();
            _self.deleteItem(item.id);
        });

        listItem.appendChild(toggleButtons);
        listItem.appendChild(deleteButton);
        listItem.appendChild(nameLabel);

        let itemsList = document.getElementById('items-list');
        itemsList.appendChild(listItem);
    }


    enabled(event, itemId) {
        let updateUrl = itemListData.update_url;
        updateUrl = updateUrl.replace('{id}', itemId);

        const form = document.querySelector('form.' + itemListData.page_class);
        if (form) {
            const input = form.querySelector( 'input[name="' + itemId + '"]');
            if (input.checked != null) {
                const formData = new FormData();
                formData.append('is_active', !input.checked);
                formData.append('can_produce', '1');
                fetch(updateUrl, {
                    method: "POST",
                    body: formData,
                    headers: {
                        accept: 'application/json'
                    }
                })
                    .then((response) => response.json());
            }
        }
    }

    getParams() {
        let itemParams = itemListParams;
        let formData = new FormData();
        const form = document.querySelector('form.' + itemListData.page_class);
        if (form) {
            Object.entries(itemParams).map(function ([name, type]) {
                const input = form.querySelector(type + '[name="' + name + '"]');
                if (input && input.value) {
                    formData.append(name, input.value);
                }
            });
        }
        return formData;
    }

}